import Amplify from 'aws-amplify'

Amplify.configure({
    Auth: AMPLIFY_AUTH,
    API: {
      endpoints: [
        AMPLIFY_API_ENDPOINT
      ]
    }
});